module.exports = __webpack_public_path__ + "static/media/location.b1043431.svg";